<template>
  <div>
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuName')" prop="skuName">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseOrder2.form.skuName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="SKU" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col v-if="setFlag != 'draft'" :span="colSpan">
          <el-form-item :label="$t('table.statusText')">
            <BjSelectLov v-model="tempStatus" :option-list="GOODS_SKU_STATUS_NORMAL_STRING" :placeholder="$t('table.statusText')" :collapse-tags="tempStatus && tempStatus.length > 2" multiple />
          </el-form-item>
        </el-col>
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY" :span="colSpan" prop="dimensionsChecked">
          <el-form-item :label="$t('goodsPage.Dimensional')">
            <BjSelectLov v-model="queryParams.dimensionsChecked" :option-list="STATUS_YES_TRUE" :placeholder="$t('goodsPage.Dimensional')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY" :span="colSpan" prop="isHide">
          <el-form-item :label="$t('BusinessPurchaseForecast.skuStatus')">
            <BjSelectLov v-model="queryParams.isHide" :option-list="HIDE_STATUS_ENABLED_NUM" :placeholder="$t('BusinessPurchaseForecast.skuStatus')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY" :span="colSpan">
          <el-form-item :label="$t('BjDialogListConfig.Producttype')">
            <BjSelectLov v-model="queryParams.itemType" :option-list="ITEM_TYPE_CHOOSE" :placeholder="$t('BjDialogListConfig.Producttype')" />
          </el-form-item>
        </el-col> -->
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('customerNameText')" prop="loginName">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Barcode')" prop="barCode">
            <BjInput v-model="queryParams.barCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsSku.detail.Barcode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">
          <el-button v-if="$store.getters.cusId" type="primary" @click="onCreate('left')">{{ $t('ExcelConfig.Title') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onExportORDINARY">{{ $t('exportText') }}</el-button>
          <el-button v-if="queryParams.setFlag == GOODS_COMBO_TYPES.ORDINARY && $store.getters.cusId" type="primary" class="main-btn" @click="onAdd">{{ $t('goodsSku.page.commonSKU') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onDownload">{{ $t('downloadText') }}</el-button>
          <el-button type="primary" @click="visibleTooltip = true">{{ $t('goodsPage.rule') }}</el-button>
          <el-button type="primary" @click="deleteSelect">{{ $t('bulkDelText') }}</el-button>
          <el-button type="primary" @click="bulkDisable">{{ $t('bulkInactiveText') }}</el-button>
          <el-button type="primary" @click="onExportHistory('SGOO.SKU_IMPORT')">{{ $t('importHistoryText') }}</el-button>
        </el-col>
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.PACKAGE">
          <el-button v-if="$store.getters.cusId" type="primary" @click="onCreate('right')">{{ $t('ExcelConfig.Title') }}</el-button>
          <el-button v-if="queryParams.setFlag == GOODS_COMBO_TYPES.PACKAGE && $store.getters.cusId" type="primary" class="main-btn" @click="onAdd">{{ $t('goodsSku.page.packageSKU') }}</el-button>
          <el-button type="primary" @click="onExportHistory('SGOO.PACKAGE_SKU_IMPORT_CSG')">{{ $t('importHistoryText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <!-- 非草稿 才展示状态列 -->
          <el-table-column v-if="
              (col.prop !== 'bjTableAction' && col.prop !== 'status') ||
                (col.prop === 'status' && setFlag !== 'draft')
            " :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <div v-else-if="col.prop === 'materialMainImages'" class="flex flex-spacebetween">
                <BjViewUrl :url="(scope.row[col.prop] || [])[0]" height="80px" preview />
              </div>
              <template v-else-if="col.prop === 'skuName'">
                <span v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">
                  {{ scope.row[col.prop] }}</span>
                <span v-else>
                  <el-tag v-if="setFlag == 'draft' && scope.row.setFlag == 1">{{ $t('goodsSku.page.Set') }}</el-tag>
                  {{ scope.row[col.prop] }}</span>
              </template>
              <template v-else-if="col.prop === 'barCode'">
                <span v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">{{ scope.row[col.prop] }}</span>
              </template>
              <template v-else-if="col.prop === 'volume'">
                {{ ((scope.row['length'] * scope.row['width'] * scope.row['height']) / 1000000).toFixed(6) }}m³
              </template>
              <template v-else-if="col.prop === 'cartonCBM'">
                {{ ((scope.row['cartonLength'] * scope.row['cartonWidth'] * scope.row['cartonHeight']) / 1000000).toFixed(6) }}m³
              </template>
              <el-tag v-else-if="col.prop === 'status'">{{ $t(GOODS_SKU_STATUS.bjGet(scope.row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'needExpired'">{{ $t(STATUS_YES_NUM.bjGet(scope.row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'dimensionsChecked'">{{ $t(STATUS_YES_TRUE.bjGet(scope.row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'isHide'">{{ $t(HIDE_STATUS_ENABLED_NUM.bjGet(scope.row[col.prop])) }}</el-tag>
              <!-- 价格 显示 -->
              <span v-else-if="col.prop.toLocaleLowerCase().includes('price')">{{ $number2money(scope.row[col.prop]) }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <div v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">
                <el-button v-permission:CSGGoodsSkuOrdinaryView type="text" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button v-permission:CSGGoodsSkuOrdinaryEdit type="text" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button v-if="props.row.isHide" type="text" @click="onEnable(props.row)">{{ $t('enableText') }}</el-button>
                <el-button v-if="!props.row.isHide" type="text" @click="onDisable(props.row)">{{ $t('disableText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </div>
              <div v-if="setFlag == GOODS_COMBO_TYPES.PACKAGE">
                <el-button v-permission:CSGGoodsSkuPackageView type="text" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button v-permission:CSGGoodsSkuPackageEdit type="text" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 导入弹窗 -->
    <ExcelImportDialog ref="ExcelImport" @submit="onSubmit"/>

    <BjDialog v-show="visibleTooltip" :visible="visibleTooltip" @close="visibleTooltip = false">
      <skuRule></skuRule>
    </BjDialog>
    <!--导入历史-->
    <ExportHistory ref="ExportHistoryRefs" :title="$t('importHistoryText')" width="850px" v-show="visible" :visible="visible" @close="visible = false" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import ExportHistory from './exportHistory.vue';
import { goodsApi } from '@/api';
import {
  GOODS_SKU_STATUS_NORMAL,
  GOODS_SKU_STATUS,
  GOODS_COMBO_TYPES,
  STATUS_YES_TRUE,
  HIDE_STATUS_ENABLED_NUM,
  STATUS_YES_NUM,
  ITEM_TYPE_CHOOSE,
} from '@/utils/constants';
import papa from 'papaparse';
import ExcelImportDialog from './ExcelImportDialog.vue';
import skuRule from './skuRule.vue';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
import JsBarcode from 'jsbarcode';
import JSZip from 'jszip';

// 可以提交审核的状态：0草稿  1被驳回  5已生效(被驳回)
const CAN_SUBMIT_STATUS = [0, 1, 5];
// 可以编辑的状态：0草稿  1被驳回   3已生效   5已生效(被驳回)
// const CAN_EDIT_STATUS = [0, 1, 3, 5];
// 可以删除的状态：0草稿  1被驳回  2审核中
const CAN_DELETE_STATUS = [0, 1, 2];
// 可以同步到三方的状态： 3已生效  4已生效-编辑中  5已生效(被驳回)
// const CAN_SYNC_STATUS = [3, 4, 5];
const GOODS_SKU_STATUS_NORMAL_STRING = [
  ...GOODS_SKU_STATUS_NORMAL.map(e => {
    return {
      ...e,
      value: e.value + '',
    };
  }),
];

export default {
  name: 'BusinessGoodsSkuPageOrdinaryPackage',
  components: {
    ExcelImportDialog,
    skuRule,
    BjSelectCustomer,
    ExportHistory,
  },
  mixins: [pageMiXin],
  props: {
    setFlag: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      colSpan: 4,
      // CAN_EDIT_STATUS,
      CAN_SUBMIT_STATUS,
      CAN_DELETE_STATUS,
      GOODS_COMBO_TYPES,
      GOODS_SKU_STATUS,
      STATUS_YES_TRUE,
      HIDE_STATUS_ENABLED_NUM,
      STATUS_YES_NUM,
      ITEM_TYPE_CHOOSE,
      GOODS_SKU_STATUS_NORMAL_STRING,
      queryApi: goodsApi.getSku,
      // 查询参数
      tempStatus: [],
      queryParams: {
        spuCode: null,
        skuCode: null,
        spuName: null,
        skuName: null,
        dimensionsChecked: null,
        isHide: null,
        itemType: this.setFlag == GOODS_COMBO_TYPES.ORDINARY ? 'item' : null,
        status: [1, 2, 3, 4, 5],
        setFlag: this.setFlag,
        cusId: null,
        barCode: null,
      },
      // 普通sku
      labelList1: [
        { label: this.$t('goodsPage.skuCode'), prop: 'standardSkuCode', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('goodsSku.detail.Barcode'), prop: 'barCode', isCheck: true, disabled: false, width: 125 },
        { label: this.$t('goodsPage.skuName'), prop: 'skuName', isCheck: true, disabled: false, width: 125 },
        // { label: this.$t('BjDialogListConfig.Producttype'), prop: 'itemType', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.length'), prop: 'length', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.width'), prop: 'width', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.height'), prop: 'height', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.weight'), prop: 'weight', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.volume'), prop: 'volume', isCheck: true, disabled: false },
        { label: this.$t('goodsSku.detail.itemPerCarton'), prop: 'qty', isCheck: true, disabled: false },
        { label: this.$t('goodsSku.detail.cartonLength'), prop: 'cartonLength', isCheck: true, disabled: false },
        { label: this.$t('goodsSku.detail.cartonWidth'), prop: 'cartonWidth', isCheck: true, disabled: false },
        { label: this.$t('goodsSku.detail.cartonHeight'), prop: 'cartonHeight', isCheck: true, disabled: false },
        { label: this.$t('goodsSku.detail.cartonWeight'), prop: 'cartonWeight', isCheck: true, disabled: false },
        { label: this.$t('CartonText')+' / '+this.$t('billingPage.CBM'), prop: 'cartonCBM', isCheck: true, disabled: false,width:103 },
        { label: this.$t('billingPage.description'), prop: 'skuDesc', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.costPrice'), prop: 'costPrice', isCheck: true, disabled: false },
        { label: this.$t('table.statusText'), prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.need'), prop: 'needExpired', isCheck: true, disabled: false },
        { label: this.$t('goodsPage.Dimensional'), prop: 'dimensionsChecked', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseForecast.skuStatus'), prop: 'isHide', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 183 },
      ],
      // 套餐sku
      labelList2: [
        { label: 'SKU', prop: 'standardSkuCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('BusinessPurchaseOrder2.form.skuName'), prop: 'skuName', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      skuTableRowData: [],
      visibleTooltip: false,
      visible: false,
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
    labelList() {
      if (this.queryParams.setFlag === GOODS_COMBO_TYPES.ORDINARY) {
        return this.$store.getters?.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      } else {
        return this.$store.getters?.cusId ? this.labelList2.filter(item => item.prop != 'cusId') : this.labelList2;
      }
    },
    CAN_EDIT_STATUS() {
      if (this.$store.getters.cusId) {
        return [0, 1, 5];
      } else {
        return [0, 1, 3, 5];
      }
    },
  },
  watch: {
    tempStatus(v, o) {
      if (Array.isArray(v) && v.length) {
        const TEMP = [];
        v.forEach(e => {
          e = e.split(',');
          TEMP.push(...e);
        });
        this.queryParams.status = TEMP.map(e => Number(e));
      } else {
        this.queryParams.status = [];
        GOODS_SKU_STATUS_NORMAL.map(e => e.value).forEach(e => {
          this.queryParams.status.push(...e);
        });
      }
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
  },
  methods: {
    onSubmit(event){
      this.handleQuery()
      this.onExportHistory(event)
    },
    onExportHistory(event) {
      if(event == 'SGOO.SKU_IMPORT'){
        this.$refs.ExportHistoryRefs.queryParams={
          status: null,
          errorReason: null,
          cusId: this.$store.getters.cusId || null,
          SKU_History: true,
          templateCode: 'SGOO.SKUS_IMPORT_CSG',
        }
      }
      if(event == 'SGOO.PACKAGE_SKU_IMPORT_CSG'){
        this.$refs.ExportHistoryRefs.queryParams={
          status: null,
          errorReason: null,
          cusId: this.$store.getters.cusId || null,
          SKU_History: true,
          templateCode: event,
        }
      }
      this.visible = true;
      this.$refs.ExportHistoryRefs.timeON()
    },
    generateBarcodeBlob(value, format = 'CODE128') {
      const canvas = document.createElement('canvas');
      canvas.width = 38;
      canvas.height = 25;
      JsBarcode(canvas, value, {
        format: format,
        lineColor: "#000",
        width: 5,
        height: 400,
        fontSize: 50,
        textMargin: 30,
        marginBottom: 50,
        marginLeft: 100,
        marginRight: 100,
        fontOptions: 'bold',
        displayValue: true,
      });
      return new Promise((resolve) => {
        canvas.toBlob(blob => { resolve(blob) }, 'image/png');
      });
    },
    async onDownload() {
      if (!this.selectedRows.length) return this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
      const values = this.selectedRows.map(item=> item.barCode || item.skuCode )
      const regex = /^[!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
      const barcode = values.filter(item => regex.test(item));
      console.log(222222, barcode)
      const zip = new JSZip();
      for (let i = 0; i < barcode.length; i++) {
        const blob = await this.generateBarcodeBlob(barcode[i]);
        zip.file(`${barcode[i]}.png`, blob);
      }
      zip.generateAsync({ type: 'blob' })
        .then(function(content) {
          const url = window.URL.createObjectURL(content);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'barcodes.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
      });
    },
    onCreate(event) {
      if(event == 'left'){
        this.$refs.ExcelImport.lovCode = 'SGOO.SKU_IMPORT'
      }else if(event == 'right'){
        this.$refs.ExcelImport.lovCode = 'SGOO.PACKAGE_SKU_IMPORT_CSG'
      }
      this.$refs.ExcelImport.show();
    },
    onExportORDINARY() {
      const fileName = `Sku List`;
      if (!this.selectedRows.length) return this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
      let csvData = [];
      this.selectedRows.forEach(async (item) => {
        csvData.push({
          'SKU': item.standardSkuCode,
          'Customer Name': this.customerList.bjGet(item.cusId),
          'Barcode': item.barCode,
          'Product Name': item.skuName,
          'Product type': item.itemType,
          'Unit/L': item.length,
          'Unit/W': item.width,
          'Unit/H': item.height,
          'Unit/WT': item.weight,
          'Unit/CBM': `${(item['length'] * item['width'] * item['height']) / 1000000}m³`,
          'Unit per Carton': item.qty,
          'Is It Wine': item.fragile > 0 ? 'Yes' : 'No',
          'Description': item.skuDesc,
          'costPrice': item.costPrice,
          'Status': this.$t(GOODS_SKU_STATUS.bjGet(item.status)),
          'Batch and Expiration': this.$t(STATUS_YES_NUM.bjGet(item.needExpired)),
          'Dimension Verification': this.$t(STATUS_YES_TRUE.bjGet(item.dimensionsChecked)),
          'SKU Status': this.$t(HIDE_STATUS_ENABLED_NUM.bjGet(item.isHide)),
        });
      });
      csvData.forEach(item => {
        if (this.$store.getters?.cusId) {
          delete item['Customer Name'];
        }
      });
      setTimeout(() => {
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        csvData = null;
      }, 1000);
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.cusId = null;
      this.queryParams.itemType = this.setFlag == GOODS_COMBO_TYPES.ORDINARY ? 'item': null;
      this.queryParams.dimensionsChecked = null;
      this.queryParams.isHide = null;
      this.tempStatus = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 导出套餐sku数据 */
    onExport() {
      const fileName = this.$t('goodsAudit.detail.packageSku') + new Date().toLocaleString();
      goodsApi.exportPackageSku(this.queryParams).then(res => {
        if (!res.length) return;
        const csvData = [];
        res.forEach(item => {
          csvData.push({
            'skuCode': item.skuCode,
            'costPrice': item.costPrice
          });
        });
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        document.body.appendChild(download);
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        document.body.removeChild(download);
      });
    },
    /** 新建 */
    onAdd() {
      if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('CSGGoodsSkuOrdinaryAdd');
      } else if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('CSGGoodsSkuPackageAdd');
      } else {
        this.$toPage('CSGGoodsSkuOrdinaryAdd');
      }
    },

    /** 查看 */
    onView(row) {
      // 通过row 判断 是套餐还是普通SKU
      if (row.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('CSGGoodsSkuOrdinaryView', {
          id: row.id,
          skuCode: row.skuCode,
          type: 'see'
        });
      } else if (row.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('CSGGoodsSkuPackageView', {
          id: row.id,
          skuCode: row.skuCode,
        });
      } else {
        this.$toPage('CSGGoodsSkuOrdinaryView', {
          id: row.id,
          skuCode: row.skuCode,
        });
      }
    },
    /** 编辑操作 */
    onEdit(row) {
      const API_DATA = {
        setFlag: row.setFlag,
        skuList: [row.skuCode],
      };
      // 通过row 判断 是套餐还是普通SKU
      if (row.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('CSGGoodsSkuOrdinaryEdit', {
          id: row.id,
          skuCode: row.skuCode,
          setFlag: this.setFlag,
        });
      }
      if (row.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        goodsApi.editSkulist(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$toPage('CSGGoodsSkuPackageEdit', {
              id: row.id,
              skuCode: row.skuCode,
              setFlag: this.setFlag,
            });
          }
        });
      }
    },
    // 启用
    onEnable(row){
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        goodsApi.goodsControlHideShow({ids: [row.id],isHide:0}).then(res => {
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      })
    },
    // 禁用
    onDisable(row){
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        goodsApi.goodsControlHideShow({ids: [row.id],isHide:1}).then(res => {
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      })
    },
    // 批量禁用
    bulkDisable(){
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      if (this.selectedRows.some(e => e.isHide == 1)) {
        this.$message.warning(this.$t('ThreePartySalesOrder.msgError1'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        goodsApi.goodsControlHideShow({ids: ids,isHide:1}).then(res => {
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      })
    },
    // 行内删除按钮
    onDel(row) {
      this.$confirm(`${this.$t('goodsAudit.Ps1')} ${row.standardSkuCode}，${this.$t('goodsAudit.Ps2')}?`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        if (row.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
          const API_DATA = {
            setFlag: row.setFlag,
            skuList: [row.skuCode],
          };
          this.deleteApi(API_DATA);
        }
        if (row.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
          const API_DATA = {
            setFlag: row.setFlag,
            skuList: [row.skuCode],
          };
          this.deleteApi(API_DATA);
        }
      });
    },
    deleteApi(API_DATA) {
      goodsApi.delSkulist(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 批量删除
    deleteSelect() {
      console.log('this.selectedRows', this.selectedRows);
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          // 只调用一次接口，批量删除选中的 SKU
          const API_DATA = {
            setFlag: 0, // 固定为普通商品类型
            skuList: this.selectedRows.map(item => item.skuCode),
          };
          return goodsApi.delSkulist(API_DATA);
        })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 2000);
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item__content {
  height: 29px !important;
}
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
